import React, {useState} from 'react';
import {createUseStyles} from 'react-jss';
import cn from 'classnames';
import {Form as FormikForm, Formik, FormikHelpers, FormikValues} from 'formik';
import * as Yup from 'yup';
import PrimaryButton from '../../ui/PrimaryButton';
import TextButton from '../../ui/TextButton';
import UIInput from '../../ui/form/UIInput';
import FormSection from '../../ui/form/FormSection';
import FormField from '../../ui/form/FormField';
import {EventType, LicenseType} from '../../schema';
import UICheckbox from '../../ui/form/UICheckbox';
import TagInput from '../../ui/form/TagInput';

type FormProps = {
  backLink: string;
  eventTypes: EventType[],
  licenseType?: LicenseType,
  onSubmit?: (input: any) => void;
}

export default function LicenseTypeForm({backLink, licenseType, eventTypes, onSubmit}: FormProps) {
  const [typeIds, setTypeIds] = useState(licenseType?.eventTypes.map((type) => type.id) || []);

  const onFormSubmit = (values: FormikValues, helpersReact: FormikHelpers<FormikValues>) => {
    helpersReact.setSubmitting(true);
    if (onSubmit) {
      onSubmit({...values, typeIds});
      helpersReact.setSubmitting(false);
    }
  };
  const styles = formStyles();

  const handleTypeCheck = (typeId: string) => {
    if (typeIds.includes(typeId)) {
      setTypeIds(typeIds.filter((id) => id !== typeId));
    } else {
      setTypeIds([...typeIds, typeId]);
    }
  };

  const initialValues = {
    name: licenseType?.name || '',
    tags: licenseType?.tags || ''
  };
  const validation = Yup.object({
    name: Yup.string().required('Required')
  });


  return (
    <Formik initialValues={initialValues} validationSchema={validation} onSubmit={onFormSubmit}>
      <FormikForm>
        <div className={cn('mb-5', styles.formWidth)}>
          <FormSection>
            <FormField id="name" label="Name" required={true}>
              <UIInput name="name" id="name" className="w-full"/>
            </FormField>
            <FormField id="tags" label="Tags"
                       tooltip={<div className="w-64">Tags are assigned to trainers when they get license of this type,
                         and available in API</div>}>
              <TagInput name="tags" id="tags" value={licenseType?.tags.join(',')}/>
            </FormField>
            <FormField id="typeIds" label="Event types"
                       tooltip={<div className="w-64">When trainers get license of this type, they get access to
                         the selected event types<br/><br/>
                         You can create a license type without assigning any event types to it. In this case, you have
                         to give access to event types manually to trainers.
                       </div>}>
              <div className="flex flex-col mt-2">
                {eventTypes.map((eventType) =>
                  (<UICheckbox id={eventType.id} key={eventType.id} label={eventType.name}
                               checked={typeIds.includes(eventType.id)} onChange={(id) => handleTypeCheck(id)}/>)
                )}
              </div>
            </FormField>
            <div className="pt-6 flex flex-row justify-start">
              <PrimaryButton className="w-32 mr-6">Save</PrimaryButton>
              <TextButton onClick={() => window.location.assign(backLink)}>Cancel changes</TextButton>
            </div>
          </FormSection>
        </div>
      </FormikForm>
    </Formik>
  );
}

const formStyles = createUseStyles({
  formWidth: {
    maxWidth: '818px'
  }
});
